import React from "react";

interface PerformanceMetricProps {
  label: string;
  current: number;
  target: number;
  unit: string;
}

export const PerformanceMetric: React.FC<PerformanceMetricProps> = ({
  label,
  current,
  target,
  unit,
}) => {
  const getProgressColor = () => {
    if (current >= target) return "text-green-400";
    if (current >= target * 0.8) return "text-yellow-400";
    return "text-red-400";
  };

  const getProgressWidth = () => {
    const progress = Math.min((current / target) * 100, 100);
    return `${progress}%`;
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-gray-400">{label}</span>
        <span className={`text-sm font-medium ${getProgressColor()}`}>
          {current.toFixed(1)}
          {unit}
        </span>
      </div>
      <div className="w-full bg-gray-700 rounded-full h-2">
        <div
          className="bg-green-500 h-2 rounded-full transition-all duration-500"
          style={{ width: getProgressWidth() }}
        />
      </div>
      <div className="text-xs text-gray-500 mt-1">
        Objectif: {target}
        {unit} | Actuel: {current.toFixed(1)}
        {unit}
      </div>
    </div>
  );
};

interface TrendItemProps {
  label: string;
  value: number;
  trend: string;
  format?: (value: any) => string;
}

export const TrendItem: React.FC<TrendItemProps> = ({
  label,
  value,
  trend,
  format,
}) => {
  const getTrendIcon = () => {
    switch (trend) {
      case "up":
        return "📈";
      case "down":
        return "📉";
      case "stable":
        return "➡️";
      case "good":
        return "✅";
      case "bad":
        return "❌";
      case "nodata":
        return "📊";
      default:
        return "📊";
    }
  };

  const getTrendColor = () => {
    switch (trend) {
      case "up":
        return "text-green-400";
      case "down":
        return "text-red-400";
      case "stable":
        return "text-gray-400";
      case "good":
        return "text-green-400";
      case "bad":
        return "text-red-400";
      case "nodata":
        return "text-gray-400";
      default:
        return "text-gray-400";
    }
  };

  return (
    <div className="flex justify-between items-center">
      <span className="text-sm text-gray-400">{label}</span>
      <div className="flex items-center gap-2">
        <span className={`text-sm font-medium ${getTrendColor()}`}>
          {format ? format(value) : value}
        </span>
        <span className="text-lg">{getTrendIcon()}</span>
      </div>
    </div>
  );
};
